import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function instructionReducer() {
    return combineReducers({
        PersOffHelp_GetHelpForPO: createItemReducer("Instructions", "PersOffHelp.GetHelpForPO", false),
        PersOffHelpDoc_GetHelpFileForPO: createItemReducer("Instructions", "PersOffHelpDoc.GetHelpFileForPO", false)
    });
}